import { render, staticRenderFns } from "./TableNormal.vue?vue&type=template&id=a9ae5e2a&scoped=true&"
import script from "./TableNormal.vue?vue&type=script&lang=js&"
export * from "./TableNormal.vue?vue&type=script&lang=js&"
import style0 from "./TableNormal.vue?vue&type=style&index=0&id=a9ae5e2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ae5e2a",
  null
  
)

export default component.exports